<template>
  <div>
    <b-row>
      <b-col cols="12" sm="12">
        <b-card>
          <div class="d-flex justify-content-between">
            <h2 class="mb-2">{{ $t('clinic.Doctor-Information') }}</h2>
          </div>
          <div>
            <h5 class="my-2">
              <b>{{ $t('clinic.doctors-name') }} :</b>
              <p class="mx-2 d-inline d-inline">
                {{ doctorData.name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t('clinic.doctors-phone') }} :</b>
              <p class="mx-2 d-inline d-inline">
                {{ doctorData.phone }}
              </p>
            </h5>
          </div>

          <hr class="invoice-spacing" />
          <h2 class="my-2">{{ $t('clinic.Doctor-Updates') }}</h2>
          <div>
            <h5 class="my-2">
              <b>{{ $t('clinic.Date-of-Last-Update-Doctor') }}:</b>
              <p class="mx-2 d-inline">{{ doctorData.updated_at }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t('clinic.Doctor-Added-At') }}:</b>
              <p class="mx-2 d-inline">{{ doctorData.created_at }}</p>
            </h5>
          </div>
          <hr class="invoice-spacing" />
        </b-card>
        <DoctorSurgeriesHistory />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BCardText,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue';

import DoctorSurgeriesHistory from '@/views/hospital/DoctorSurgeriesHistory.vue';

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormInput,
    BFormGroup,
    BCard,
    BCardText,
    BButton,

    DoctorSurgeriesHistory,
  },
  data() {
    return {
      loading: true,
      params: {
        form: {},
        path: '',
      },
      doctorData: {},
      surgeries: [],
    };
  },
  mounted() {
    this.getPatientSurgeryInfo();
  },

  methods: {
    async getPatientSurgeryInfo() {
      await this.getPatient(`doctor/${this.$route.params.id}`);
      this.loading = false;

      this.doctorData = this.all_data;
    },
  },
};
</script>
